import {FC, useCallback, useState} from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {get, partial} from "lodash";
import {Collapse} from "@mui/material";
import {SelectProjectTitle, subMenuProjectLinks} from "modules/constants";
import {Language} from "modules/enums";
import {BaseButton} from "components/Common";
import {ReactComponent as Arrow} from "assets/images/icons/smallArrow.svg";
import {INavLink} from "modules/types";
import {breakpoints} from "assets/theme";

const ProjectLinksContainer = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	margin-left: auto;
	font-family: "Hind", sans-serif;
	font-weight: 600;
	font-size: 16px;
	line-height: 140%;
	color: ${({theme}) => theme.colorPalette.black};

	@media (min-width: ${breakpoints.medium}) {
		background: ${({theme}) => theme.colorPalette.white};
	}
`;

const SelectProject = styled(BaseButton)`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	padding: 10px;
	font: inherit;
	gap: 10px;

	@media (min-width: ${breakpoints.medium}) {
		min-width: 140px;
		background: #ffffff;

		svg path {
			fill: #202020;
		}
	}
`;

const SelectProjectText = styled.span`
	color: ${({theme}) => theme.colorPalette.black};
	display: none;

	@media (min-width: ${breakpoints.medium}) {
		display: block;
	}
`;

const ProjectLink = styled.a`
	display: flex;
	background: ${({theme}) => theme.colorPalette.white};
	width: 100%;
	padding: 10px;
	border-top: 1px solid #cccccc;
`;

const Links = styled.div`
	position: absolute;
	top: 100%;
	right: 0;
	z-index: 100;

	@media (min-width: ${breakpoints.medium}) {
		left: 0;
		min-width: 140px;
	}

	.MuiCollapse-root {
		border: 1px solid #cccccc;
		border-top: none;
	}
`;

const Overlay = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	z-index: -1;
`;

export const ProjectLinks: FC = () => {
	const {t, i18n} = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const projectLinks = get(
		subMenuProjectLinks,
		i18n.language,
		subMenuProjectLinks[Language.English]
	) as INavLink[];

	const toggleIsOpenProjectsLinks = useCallback(() => {
		setIsOpen((prev) => !prev);
	}, [setIsOpen]);

	return (
		<ProjectLinksContainer>
			<SelectProject onClick={toggleIsOpenProjectsLinks}>
				<SelectProjectText>{t(SelectProjectTitle)}</SelectProjectText>
				<Arrow />
			</SelectProject>

			<Links>
				<Collapse in={isOpen}>
					<Overlay onClick={partial(setIsOpen, false)} />

					{projectLinks.map(({title, href}) => (
						<ProjectLink key={href} href={href}>
							{t(title)}
						</ProjectLink>
					))}
				</Collapse>
			</Links>
		</ProjectLinksContainer>
	);
};
